import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { queryKeys, NEIGHBORHOOD_SELECT, SSR_STALE_TIME } from "@/lib/queryKeys";

export const useNeighborhoods = () => {
  return useQuery({
    queryKey: queryKeys.neighborhoods,
    staleTime: SSR_STALE_TIME,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('neighborhoods')
        .select(NEIGHBORHOOD_SELECT)
        .order('name');
      
      if (error) throw error;
      return data;
    }
  });
};
